var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "14px",
    height: "30px",
    viewBox: "0 0 14 30",
    enableBackground: "new 0 0 14 30",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1E1E1E",
    d: "M14,9.712H9.232v-3.11c0-1.172,0.777-1.442,1.326-1.442c0.547,0,3.364,0,3.364,0V0.016L9.288,0 C4.145,0,2.975,3.832,2.975,6.287v3.425H0v5.3h2.975c0,6.799,0,14.988,0,14.988h6.257c0,0,0-8.271,0-14.988h4.223L14,9.712z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.0d1ed68ebe149d600fa0a5bbeff58f09.svg";
export { ForwardRef as ReactComponent };